import React from 'react';
import t from 'prop-types';
import Pestana from './pestana';

var PestanaNormal = function PestanaNormal(_ref) {
  var boton = _ref.boton,
      onBoton = _ref.onBoton;

  if (window.electronContext || window.parent.electronContext) {
    var tipoVinculo = boton.vinculo.split(":")[0];

    if (tipoVinculo === 'funcion,imprimirEjercicio') {
      return null;
    }
  }

  return React.createElement(Pestana, {
    boton: boton,
    onBoton: onBoton
  });
};

PestanaNormal.propTypes = process.env.NODE_ENV !== "production" ? {
  boton: t.object,
  onBoton: t.func
} : {};
export default PestanaNormal;